<div class="modal active">
    <div class="modal__container modal__container--sm">
      <div class="fields">
        <h2>Procedure Import Options</h2>
        <div class="close" (click)="cancelImport()"><img src="/assets/img/close-white.svg" alt="" /></div>
        <div class="fields__container">
          <form autocomplete="off"  name="ngImportCsvForm" #ngForm="ngForm" id="importCsvForm" class="active">
            <div class="fields__block">
              <div class="fields__block__section">
                <div class="title">
                  <h4>Source Files</h4>
                  <span> </span>
                </div>
                <div class="input-fields">
                  <div *ngFor="let type of fileTypes">
                    <label for="">{{type}} File</label>
                    <input
                      required
                      maxlength="300"
                      type="file"
                      name="filenameType_{{type}}"
                      id="fileIDType_{{type}}"
                      ng-model="filenameType_{{type}}"
                      (change)="saveFile(type,$event)"
                      [accept]="importFormat.fileExtension"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="fields__btn">
              <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" (click)="startImport();" [disabled]="filesMap.size != 5">
                Import
              </button>
              <button class="gray" (click)="cancelImport()">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
